import ComponentManager from "../../componentFramework";
import {default as JsfAjaxStatus, CustomStatusElementCallback} from "../../scripts/jsf/JsfAjaxStatus";
import {
	JsfAjaxEvent,
	JsfAjaxRequestEvent,
} from "../../scripts/jsf/JsfAjax";

/**
 * To use this screen blocker enable it by using the static enableBlockerOnRequest method.
 * This will add some data to the internal options object.
 * For example:
 * AjaxStatusScreenBlocker.enableBlockerOnRequest(requestInternalOptions," Optional text");
 *
 * For a full example see EditContentAction.ts
 */
@ComponentManager.register()
export default class AjaxStatusScreenBlocker {
	public static componentStyleClass = "ajaxStatusScreenBlocker";
	public static readonly textContainerStyleClass = "ajaxStatusScreenBlocker__text";

	private static readonly requestInternalOptionsKeyToEnable = "ajaxStatusScreenBlocker-enabled";

	public static enableBlockerOnRequest(
		requestInternalOptions: any,
		text?: string,
		doc: Document = window.document
	) {
		requestInternalOptions[AjaxStatusScreenBlocker.requestInternalOptionsKeyToEnable] = true;

		// Make sure there is a blocker element in the DOM and if there is not one, create it.
		let blockerElement = doc.querySelector<HTMLElement>("." + AjaxStatusScreenBlocker.componentStyleClass);
		if (blockerElement === null) {
			blockerElement = doc.createElement("div");
			blockerElement.classList.add(AjaxStatusScreenBlocker.componentStyleClass);
			const textDiv = doc.createElement("div");
			textDiv.classList.add(AjaxStatusScreenBlocker.textContainerStyleClass);
			textDiv.innerText = text !== undefined ? text : "";
			blockerElement.appendChild(textDiv)
			doc.body.appendChild(blockerElement)
			ComponentManager.getInstance(doc).createComponentInstance(AjaxStatusScreenBlocker, blockerElement);
		}
		let textDiv = blockerElement.querySelector<HTMLElement>("." + AjaxStatusScreenBlocker.textContainerStyleClass);
		if (textDiv === null) {
			textDiv = doc.createElement("div");
			textDiv.classList.add(AjaxStatusScreenBlocker.textContainerStyleClass);
			blockerElement.appendChild(textDiv)
			doc.body.appendChild(blockerElement)
		}
		textDiv.innerText = text !== undefined ? text : "";
	}

	constructor(private readonly rootElement: HTMLElement) {
		JsfAjaxStatus.getInstance().addEventBeginListener(this.onJsfAjaxStatusEventBegin);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		JsfAjaxStatus.getInstance().removeEventBeginListener(this.onJsfAjaxStatusEventBegin);
	}

	private readonly onJsfAjaxStatusEventBegin = (
		event: JsfAjaxRequestEvent,
		addStatusElement: (elem: Element, onComplete?: CustomStatusElementCallback) => void,
		preventGlobalStatus: () => void
	) => {
		if (event.internalOptions[AjaxStatusScreenBlocker.requestInternalOptionsKeyToEnable] === true) {
			addStatusElement(this.rootElement, this.onJsfAjaxStatusEventComplete);
			preventGlobalStatus();
		}
	}

	private readonly onJsfAjaxStatusEventComplete = (ev: JsfAjaxEvent, customStatusElem?: Element) => {
		// TODO ???
	}
}
